import ivclass from '@invideoio/web-shared/Modules/IVClass';

import ImageComponent from '@components/common/ImageComponent/ImageComponent';
import { BlogHomepageCardDetailsType, CategoryType } from 'src/types';
import BackButton from '@components/back-button';
import { PlatformType } from '@invideoio/web-shared/constants/common';
import { BrowserType } from '@constants/common';

interface CategoryHeaderSection extends BlogHomepageCardDetailsType {
  bgColor: string;
  platform: PlatformType;
  browser: BrowserType;
}
const CategoryHeaderSection = (props: CategoryHeaderSection) => {
  const { slug, image, name, description, bgColor, platform, browser } = props;
  return (
    <section
      style={{ background: bgColor }}
      className={ivclass(
        'iv-pt-[110px] lg:iv-pt-[87px] md:iv-pt-[69px] sm:iv-pt-25',
        'iv-pb-100 lg:iv-pb-[95px] md:iv-pb-60 sm:iv-pb-50',
      )}
    >
      <div className={ivclass('iv-container iv-mx-auto')}>
        <div className={ivclass('iv-grid iv-grid-cols-12 ')}>
          <div
            className={ivclass(
              'iv-col-start-2 lg:iv-col-start-2  sm:iv-col-start-1',
              'iv-col-span-7 lg:iv-col-span-7 md:iv-col-span-12 sm:iv-col-span-12',
              'iv-px-20 lg:iv-px-[0] md:iv-px-[55px] sm:iv-px-25',
              'iv-mt-15 lg:iv-mt-40 md:iv-mt-[0]',
              'sm:iv-leading-[49px]',
              'sm:iv-text-center',
            )}
          >
            <h1
              className={ivclass(
                'iv-text-heading-4xl iv-font-extrabold',
                'lg:iv-m-heading-4xl',
                'md:iv-text-heading-3xl',
                'sm:iv-text-heading-m',
                'iv-text-black-95',
                'iv-mb-20 lg:iv-mb-[24px] md:iv-mb-20 sm:iv-mb-15',
                'md:iv-leading-[1]',
              )}
            >
              {name}
            </h1>
            <div
              className={ivclass(
                'iv-text-heading-2xs iv-font-semibold',
                'sm:iv-text-body-3xl sm:iv-font-bold',
                'iv-text-black-50',
                'iv-mb-[70px] md:iv-mb-[45px] sm:iv-mb-20 ',
                'md:iv-leading-[34px]',
                'sm:iv-px-10',
                'lg:iv-ml-[-5px]',
              )}
            >
              {description}
            </div>
            <div
              className={ivclass(
                'md:iv-flex  sm:iv-flex sm:iv-justify-center',
                'md:iv-mr-8',
              )}
            >
              <BackButton
                isDark={true}
                buttonContent="Back to Categories"
                redirectLink={`/blog/category`}
              />
            </div>
          </div>
          <div
            className={ivclass(
              'iv-col-span-3 lg:iv-col-span-3 md:iv-col-span-12 sm:iv-col-span-12',
              'lg:iv-pl-40',
              'md:iv-my-20',
              'sm:iv-mt-50',
            )}
          >
            <div
              className={ivclass(
                'iv-pt-25 lg:iv-pt-40 md:iv-pt-15 sm:iv-pt-[0]',
                'iv-pl-40 md:iv-pl-[0] sm:iv-pl-[0]',
              )}
            >
              <ImageComponent
                elementype="imagekit"
                src={image?.url}
                alt={slug}
                className={ivclass(
                  'iv-h-[300px] iv-w-[300px]',
                  'lg:iv-h-[268px] lg:iv-w-[268px]',
                  'md:iv-h-[268px] md:iv-w-[268px]',
                  'sm:iv-h-[187px] sm:iv-w-[187px]',
                  'md:iv-mx-auto sm:iv-mx-auto',
                  'iv-rounded-[25px]',
                  'iv-object-cover',
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CategoryHeaderSection;
